import { useEffect, useState } from "react";
import axios from "axios";
import { XCircle, TimerOff, RefreshCw } from "lucide-react";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const fmt = (iso) => (iso ? new Date(iso).toLocaleString("fr-FR", { day: "2-digit", month: "2-digit", hour: "2-digit", minute: "2-digit" }) : "—");

// Tour de Contrôle : courses refusées ou ignorées (30 s sans réponse) et par quel livreur
export const BroadcastResponsesPanel = ({ onOpenUser }) => {
  const [rows, setRows] = useState(null);
  const load = () => axios.get(`${API}/admin/broadcast-responses`).then((r) => setRows(r.data)).catch(() => setRows([]));
  useEffect(() => {
    load();
    const t = setInterval(load, 20000);
    return () => clearInterval(t);
  }, []);

  return (
    <section className="rounded-3xl border border-slate-800 bg-[#0B1220] p-5 space-y-3" data-testid="broadcast-responses-panel">
      <div className="flex items-center justify-between">
        <h3 className="text-xs font-black uppercase tracking-widest text-amber-400">Courses refusées / ignorées</h3>
        <button type="button" onClick={load} className="text-slate-400 hover:text-white" data-testid="broadcast-responses-refresh"><RefreshCw size={14} /></button>
      </div>
      {!rows ? <p className="text-xs text-slate-500">Chargement…</p> : rows.length === 0 ? (
        <p className="text-xs text-slate-500" data-testid="broadcast-responses-empty">Aucun refus ni course ignorée pour le moment.</p>
      ) : (
        <div className="max-h-80 overflow-y-auto divide-y divide-slate-800">
          {rows.map((o) => (
            <div key={o.id} className="py-2.5 space-y-1" data-testid={`broadcast-response-order-${o.id}`}>
              <p className="text-xs text-white font-bold truncate">#{o.id.slice(0, 8)} · {o.order_type || "livraison"} · {Math.round(o.delivery_fee || 0)} F · {o.courier_id ? "attribuée" : o.broadcast_status}</p>
              <p className="text-[10px] text-slate-500 truncate">{o.pickup_address} → {o.delivery_address}</p>
              <div className="flex flex-wrap gap-1.5">
                {o.broadcast_responses.map((r, i) => (
                  <button type="button" key={`${r.courier_id}-${i}`} onClick={() => onOpenUser?.(r.courier_id)}
                    className={`inline-flex items-center gap-1 rounded-full px-2 py-0.5 text-[10px] font-bold ${r.action === "declined" ? "bg-red-500/15 text-red-300" : "bg-slate-700/50 text-slate-300"}`}
                    data-testid={`broadcast-response-${o.id}-${i}`}>
                    {r.action === "declined" ? <XCircle size={10} /> : <TimerOff size={10} />}
                    {r.courier_name || r.courier_id?.slice(0, 6)} · {r.action === "declined" ? "refusée" : "ignorée"} · {fmt(r.at)}
                  </button>
                ))}
              </div>
            </div>
          ))}
        </div>
      )}
    </section>
  );
};
